import React from 'react'
import Typography from '@mui/joy/Typography';
import Card from '@mui/joy/Card';
import Footer from '../components/Footer'
import mayaImg1 from "../assets/courses/media/maya1.jpeg";
import mayaImg2 from "../assets/courses/media/maya2.jpeg";
import mayaImg3 from "../assets/courses/media/maya3.jpeg";
import mayaImg4 from "../assets/courses/media/maya4.jpeg";
import mayaImg5 from "../assets/courses/media/maya5.jpeg";
import mayaImg6 from "../assets/courses/media/maya6.jpeg";
import mayaImg7 from "../assets/courses/media/media1.jpg";
import mayaImg8 from "../assets/courses/media/news1.jpg";
import mayaImg9 from "../assets/courses/media/news2.jpg";
import mayaImg10 from "../assets/courses/media/news3.jpg";
import mayaImg11 from "../assets/courses/media/news4.jpg";
import mayaImg12 from "../assets/courses/media/news5.jpg";
import mayaImg13 from "../assets/courses/media/news6.jpg";
import mayaImg14 from "../assets/courses/media/news7.jpg";
import mayaImg15 from "../assets/courses/media/news8.jpg";
import mayaImg16 from "../assets/courses/media/news9.jpg";

let courseData = [
    {
        image: mayaImg7
    },
    {
        image: mayaImg8
    },
    {
        image: mayaImg9
    },
    {
        image: mayaImg10
    },
    {
        image: mayaImg11
    },
    {
        image: mayaImg12
    },
    {
        image: mayaImg13
    },
    {
        image: mayaImg14
    },
    {
        image: mayaImg15
    },
    {
        image: mayaImg16
    },
    {
        image: mayaImg1
    },
    {
        image: mayaImg2
    },
    {
        image: mayaImg3
    },
    {
        image: mayaImg4
    },
    {
        image: mayaImg5
    },
    {
        image: mayaImg6
    },
  
]

// Featured article data
const featuredArticle = {
    image: mayaImg7,
    title: "Innovative Pine Needles Powder-Based Wastewater Treatment Device"
}

const MayaMedia = () => {
    return (
        <div className='w-full relative mt-[100px]'>
            <div className='w-10/12 mx-auto flex flex-col gap-[50px] mt-[100px]'>
                <h2 className="mb-4 text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38]">Maya in Media</h2>

                {/* Featured Article Section */}
                <div className="mb-[50px]">
                    <Card sx={{
                        width: '100%',
                        maxWidth: '1200px',
                        margin: '0 auto',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' }
                    }}>
                        <div style={{
                            width: '100%',
                            maxWidth: { xs: '100%', md: '50%' },
                            minHeight: '500px',
                            position: 'relative'
                        }}>
                            <img
                                src={featuredArticle.image}
                                alt="Pine Needles Wastewater Treatment Device"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0
                                }}
                            />
                        </div>
                        <div style={{
                            width: '100%',
                            maxWidth: { xs: '100%', md: '50%' },
                            padding: '24px'
                        }}>
                            <Typography level="h4" sx={{ fontWeight: 700, mb: 2, color: '#0e4d38' }}>
                                {featuredArticle.title}
                            </Typography>
                            <Typography level="body-md" sx={{ lineHeight: 1.6 }}>
                                Researchers at the School of Agriculture and Technology, Maya Devi University, Dehradun, have developed a pine needles powder-based wastewater treatment device that provides a low-cost, eco-friendly, and sustainable solution to the serious problem of water pollution in rural areas.
                                <br /><br />
                                This innovation is protected under the Registered Designs Act, 1949, ensuring that its unique design cannot be copied or reproduced. The process of publishing this patent took approximately one year. The device utilizes pine needles powder, a natural and biodegradable material, to reduce chemical pollution and promote environmental sustainability.
                                <br /><br />
                                It offers an affordable alternative to expensive water purification systems, enabling rural communities to access clean water and preventing the spread of waterborne diseases such as diarrhea, cholera, and typhoid. Additionally, the widespread use of this device will facilitate the reuse of fallen pine needles, reducing the risk of forest fires and improving wastewater management.
                                <br /><br />
                                This groundbreaking innovation opens new possibilities in water management and marks a significant step toward a clean, healthy, and self-sufficient future for rural communities.
                            </Typography>
                        </div>
                    </Card>
                </div>

                <h3 className="text-xl md:text-3xl font-semibold text-center text-[#0e4d38] mb-8">More Media Coverage</h3>

                {/* Grid of full images with no cropping */}
                <div className='grid grid-cols-1 md:grid-cols-3 gap-8 mb-[100px]'>
                    {courseData.map((course, index) => (
                        <div
                            key={index}
                            className="shadow-lg rounded-lg"
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%'
                            }}
                        >
                            <img
                                src={course.image}
                                loading="lazy"
                                alt="Media coverage"
                                style={{
                                    width: '100%',
                                    maxHeight: '500px',
                                    objectFit: 'contain',
                                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                    borderRadius: '8px'
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default MayaMedia